var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb',{attrs:{"links":_vm.links}}),(_vm.product)?_c('productDetailContent',{staticClass:"px-2 md:pl-16 md:pr-4",attrs:{"product":_vm.product}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }